import React, { useState } from 'react'
import { SummaryTimeView, SummaryTimeViews } from '../types'
import { Chip, Stack } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { LabeledOption } from '@e3dc-react/shell/Types/globalTypes'

interface Props {
  setPeriod: (period: SummaryTimeView) => void
}

/**
 * A select between different time views based on which the values for the summary are calculated
 * @param param0
 * @returns
 */
const SelectTimeFrame: React.VFC<Props> = ({ setPeriod }) => {
  const { t } = useCustomTranslation()
  const [timePeriodValue, setTimePeriodValue] = useState<SummaryTimeView>(SummaryTimeViews.Day)

  const options: LabeledOption<SummaryTimeView>[] = [
    { label: t('common.today'), value: SummaryTimeViews.Day },
    { label: t('common.week'), value: SummaryTimeViews.Week },
    { label: t('common.month'), value: SummaryTimeViews.Month },
    { label: t('common.year'), value: SummaryTimeViews.Year },
  ]

  const handleChange = (value: SummaryTimeView): void => {
    setTimePeriodValue(value)
    setPeriod(value)
  }

  return (
    <Stack direction="row" rowGap={1} columnGap={1} flexWrap="wrap" width={'100%'}>
      {options.map(option => (
        <Chip
          key={option.value}
          label={option.label}
          data-qa={`dashboard-summary-timeframe-${option.value}`}
          color={option.value === timePeriodValue ? 'primary' : 'default'}
          onClick={() => handleChange(option.value)}
          sx={{
            flex: 1,
            ...(option.value === timePeriodValue && {
              '&:hover, &:focus, &:active': {
                backgroundColor: theme => theme.palette.primary.main,
              },
            }),
          }}
        />
      ))}
    </Stack>
  )
}

export default SelectTimeFrame
